import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import useUpdateQuantity from './UpdateQuantity';
import useRemoveItem from './RemoveItem';
import { useCart } from './CartContext'; // Import Cart Context
import { RiDeleteBinLine } from "react-icons/ri";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import './Checkout.css';
import './CartMobile.css';

import { useStripe, useElements, PaymentElement, Elements } from '@stripe/react-stripe-js';
import BASE_URL, { getImageURL } from '../../config';

const fetchAvailableHours = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/hours/`);
    const data = await response.json();
    console.log(data);

    return data;
  } catch (error) {
    console.error("Error fetching available hours:", error);
    return [];
  }
};

// Function to get available slots for the current day
const getAvailableSlots = (hoursData) => {
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const currentDay = daysOfWeek[new Date().getDay()]; // Get current day (0-6) => Sunday to Saturday
  const dayData = hoursData.find((day) => day.day === currentDay);
  
  if (!dayData) {
    console.log("No data found for the current day:", currentDay);
    return [];
  }

  // If the day is closed, return an empty array
  if (dayData.is_closed) {
    console.log(`${currentDay} is closed today.`);
    return [];
  }

  // Filter time slots to ensure they are within the 9 AM to 5 PM range
  const filteredSlots = dayData.time_slots.filter((slot) => {
    const time = parseInt(slot.hour.split(" ")[0]);
    return time; // Only 9 AM to 5 PM (you can adjust this)
  });

  return filteredSlots;
};

// Example usage
const displayAvailableSlots = async () => {
  const availableHours = await fetchAvailableHours();
  const availableSlots = getAvailableSlots(availableHours);

  // Log the available slots or update the UI accordingly
  if (availableSlots.length > 0) {
    console.log("Available time slots for today:", availableSlots);
  } else {
    console.log("No available time slots for today.");
  }
};

// Call the function to display the available slots
displayAvailableSlots();

// Helper function to parse preparation time and convert it to total days
const parsePreparationTime = (preparationTime) => {
  const [days, time] = preparationTime.split(' ');
  const [hours, minutes, seconds] = time.split(':');
  // Convert everything to minutes
  const totalMinutes = (parseInt(days) * 24 * 60) + (parseInt(hours) * 60) + parseInt(minutes);
  return totalMinutes; // Return total preparation time in minutes
};
const NewCheckoutDe = () => {
  const navigate = useNavigate();
  const { cart, loading, error, fetchCart } = useCart(); // Use CartContext
  const { handleUpdateQuantity, loading: updating, error: updateError } = useUpdateQuantity(fetchCart);
  const { handleRemoveItem, loading: removing, error: removeError } = useRemoveItem(fetchCart);
  const [specialInstructions, setSpecialInstructions] = useState('');
  const [deliveryOption, setDeliveryOption] = useState('homeDelivery');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [availableHours, setAvailableHours] = useState([]); // Store available hours for selected day
  const [allHoursData, setAllHoursData] = useState([]); // Store all opening hours from API
  const [maxPreparationTime, setMaxPreparationTime] = useState(0); // Store max preparation time
  const [minAvailableTime, setMinAvailableTime] = useState(new Date()); // Store the earliest available time
  const [storePickupAvailable, setStorePickupAvailable] = useState(false); // Update based on availability

  // Check if ANY item in the cart requires scheduled delivery
  const requiresScheduling = cart?.items?.some(
    (cartItem) => cartItem.item.requires_scheduled_delivery === true
  ) ?? true; // Default to true if cart not loaded yet

  const [couponCode, setCouponCode] = useState("");
  const authToken = localStorage.getItem('authToken');
  const [message, setMessage] = useState("");
  const [couponresult, setCouponresult] = useState("");
  const [paymentTotal, setPaymentTotal] = useState(0); // Initialize paymentTotal state

  const deliveryType = "delivery"

  const stripe = useStripe();
const elements = useElements();

const appearance = {
  theme: "stripe",
}
const options = {
  appearance,
};
const [deliveryFee, setDeliveryFee] = useState(0);
const FREE_SHIPPING_THRESHOLD = 80;


useEffect(() => {
  // Calculate shipping from per-item shipping_price
  if (cart?.items && cart.items.length > 0) {
    const subtotal = cart.total_price;
    let fee = 0;
    if (subtotal >= FREE_SHIPPING_THRESHOLD) {
      fee = 0;
    } else {
      // Shipping = highest single item's shipping price (pay once)
      fee = Math.max(
        ...cart.items.map(cartItem => parseFloat(cartItem.item.shipping_price) || 0)
      );
    }
    setDeliveryFee(fee);
    localStorage.setItem('deliveryFee', fee);
  }
}, [cart]);

useEffect(() => {

  // Proceed only if the cart has items
  if (cart?.items && cart.items.length > 0) {
    const subtotal = couponresult?.new_total || cart.total_price;
    setPaymentTotal(subtotal + deliveryFee);
  }
}, [couponresult, cart, deliveryFee]);



const [shippingAddress, setShippingAddress] = useState({
          address_line1: '',
          address_line2: '',
          city: '',
          state: '',
          postal_code: '',
          country: 'Switzerland',
          phone: '',
        });

const [billingSameAsShipping, setBillingSameAsShipping] = useState(true);
const [billingAddress, setBillingAddress] = useState({
          address_line1: '',
          address_line2: '',
          city: '',
          state: '',
          postal_code: '',
          country: 'Switzerland',
        });
  

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setMessage("Please enter a promo code.");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Token ${authToken}`);
    myHeaders.append("Content-Type", "application/json");


    const raw = JSON.stringify({ couponcode: couponCode });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(`${BASE_URL}/api/coupon/`, requestOptions);
      const couponresult = await response.json();
      setCouponresult(couponresult); 
      setMessage(couponresult.message || "Coupon applied successfully!");

      console.log(couponresult);
    } catch (error) {
      setMessage("Failed to apply coupon. Please try again.");
      console.error(error);
    }
  };

  const handleStorePickupClick = () => {
    if (!storePickupAvailable) {
      alert('Store Pickup is not available right now');
    } else {
      setDeliveryOption('storePickup');
    }
  };

  const totalItems = cart?.items?.reduce((acc, item) => acc + item.quantity, 0) || 0;


  useEffect(() => {
    console.log(cart);
    const getHoursData = async () => {
      const hoursData = await fetchAvailableHours();
      setAllHoursData(hoursData); // Store all days' data
    };

    // Calculate max preparation time from cart items
    if (cart?.items && cart.items.length > 0) {
      const maxPrepTime = cart.items.reduce((max, item) => {
        const itemPrepTime = parsePreparationTime(item.item.preparationtime);
        return itemPrepTime > max ? itemPrepTime : max;
      }, 0);
      setMaxPreparationTime(maxPrepTime); // Set max preparation time in minutes
    }

    // Calculate the minimum available time (current time + preparation time)
    const currentTime = new Date();
    currentTime.setMinutes(currentTime.getMinutes() + maxPreparationTime);
    setMinAvailableTime(currentTime);

    getHoursData();
  }, [cart?.items, maxPreparationTime]); // Re-run when cart items change

  // Update available time slots when the selected date changes
  useEffect(() => {
    if (selectedDate && allHoursData.length > 0) {
      const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const dayName = daysOfWeek[selectedDate.getDay()];
      const dayData = allHoursData.find((d) => d.day === dayName);
      if (dayData && !dayData.is_closed && dayData.time_slots) {
        setAvailableHours(dayData.time_slots);
      } else {
        setAvailableHours([]);
      }
      setSelectedTime(''); // Reset time when date changes
    }
  }, [selectedDate, allHoursData]);

  // Check if a date is closed (Sunday or any day marked is_closed in the API)
  const isClosedDay = (date) => {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = daysOfWeek[date.getDay()];
    const dayData = allHoursData.find((d) => d.day === dayName);
    if (!dayData) return date.getDay() === 0; // Default: block only Sunday
    return dayData.is_closed;
  };

  const isValidDate = (date) => {
    if (!date) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const in30Days = new Date(today);
    in30Days.setDate(today.getDate() + 30);
    return date >= today && date <= in30Days && !isClosedDay(date);
  };

  const handleDateChange = (date) => {
    if (isValidDate(date)) {
      setSelectedDate(date);
      setCalendarVisible(false);
    } else {
      alert('Bitte wählen Sie ein gültiges Datum innerhalb der nächsten 30 Tage (geschlossene Tage ausgenommen).');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress({ ...shippingAddress, [name]: value });
  };

  const handleBillingInputChange = (e) => {
    const { name, value } = e.target;
    setBillingAddress({ ...billingAddress, [name]: value });
  };

  const minDate = minAvailableTime; // Set minDate to current time + preparation time
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30 + Math.ceil(maxPreparationTime / (24 * 60))); // Add max preparation time in days

  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };

  
  const handleCheckout = () => {
    const orderData = {
      items: cart.items.map(item => ({
        item_id: item.item.title,
        item_image: item.item.mainimage,
        quantity: item.item.quantity,
      })),
      delivery_type: deliveryType,
      delivery_date: selectedDate,
      delivery_time: selectedTime,
      billing_address: billingSameAsShipping ? shippingAddress : billingAddress,
      shipping_address: shippingAddress,
      coupon_code: couponCode,
      total: paymentTotal,
      delivery_fee: deliveryFee,
    };

    localStorage.setItem('orderData', JSON.stringify(orderData));
    navigate('/review-order');
  };

  return (
    <div className="checkout-page">
      <h1>Zur Kasse</h1>

      <div className="checkout-grid">
        {/* ── Left column: Delivery & Schedule ── */}
        <div>
          {/* Delivery type */}
          <div className="checkout-section">
            <h2 className="checkout-section-title">Lieferart</h2>
            <div className="checkout-delivery-toggle">
              <button
                className={deliveryOption === 'homeDelivery' ? 'active' : ''}
                onClick={() => setDeliveryOption('homeDelivery')}
              >
                Hauslieferung
              </button>
              <button
                className={deliveryOption === 'storePickup' ? 'active' : ''}
                onClick={handleStorePickupClick}
                disabled={!storePickupAvailable}
              >
                Abholung im Geschäft
              </button>
            </div>
          </div>

          {/* Delivery info form */}
          <div className="checkout-section">
            <h2 className="checkout-section-title">Lieferinformationen</h2>

            <div className="checkout-form-row">
              <div className="checkout-field">
                <input type="text" id="ck-firstname" name="firstname" placeholder="Vorname" />
                <label htmlFor="ck-firstname">Vorname</label>
              </div>
              <div className="checkout-field">
                <input type="text" id="ck-lastname" name="lastname" placeholder="Nachname" required />
                <label htmlFor="ck-lastname">Nachname</label>
              </div>
            </div>

            <div className="checkout-form-row full">
              <div className="checkout-field">
                <input
                  type="text" id="ck-phone" name="phone"
                  placeholder="E-Mail oder Mobiltelefonnummer"
                  onChange={handleInputChange} value={shippingAddress.phone}
                />
                <label htmlFor="ck-phone">E-Mail oder Mobiltelefonnummer</label>
              </div>
            </div>

            <div className="checkout-form-row full">
              <div className="checkout-field">
                <select id="ck-country" name="country" value={shippingAddress.country} onChange={handleInputChange}>
                  <option value="Switzerland">Schweiz</option>
                  <option value="Germany">Deutschland</option>
                </select>
                <label htmlFor="ck-country">Land</label>
              </div>
            </div>

            <div className="checkout-form-row">
              <div className="checkout-field">
                <input
                  type="text" id="ck-postal" name="postal_code"
                  placeholder="Postleitzahl" required
                  onChange={handleInputChange} value={shippingAddress.postal_code}
                />
                <label htmlFor="ck-postal">Postleitzahl</label>
              </div>
              <div className="checkout-field">
                <input
                  type="text" id="ck-city" name="city"
                  placeholder="Stadt" required
                  onChange={handleInputChange} value={shippingAddress.city}
                />
                <label htmlFor="ck-city">Stadt</label>
              </div>
            </div>

            <div className="checkout-form-row full">
              <div className="checkout-field">
                <input
                  type="text" id="ck-address" name="address_line1"
                  placeholder="Adresse" required
                  onChange={handleInputChange} value={shippingAddress.address_line1}
                />
                <label htmlFor="ck-address">Adresse</label>
              </div>
            </div>

            <div className="checkout-form-row full">
              <div className="checkout-field">
                <input
                  type="text" id="ck-apartment" name="address_line2"
                  placeholder="Wohnung, Suite usw. (optional)"
                  onChange={handleInputChange} value={shippingAddress.address_line2}
                />
                <label htmlFor="ck-apartment">Wohnung, Suite usw. (optional)</label>
              </div>
            </div>
          </div>

          {/* Rechnungsadresse */}
          <div className="checkout-section">
            <div className="checkout-form-row full">
              <label className="checkout-checkbox-label">
                <input
                  type="checkbox"
                  checked={billingSameAsShipping}
                  onChange={(e) => setBillingSameAsShipping(e.target.checked)}
                />
                <span style={{ marginLeft: '8px' }}>Rechnungsadresse entspricht der Lieferadresse</span>
              </label>
            </div>

            {!billingSameAsShipping && (
              <>
                <h2 className="checkout-section-title">Rechnungsadresse</h2>

                <div className="checkout-form-row full">
                  <div className="checkout-field">
                    <select id="ck-bill-country" name="country" value={billingAddress.country} onChange={handleBillingInputChange}>
                      <option value="Switzerland">Schweiz</option>
                      <option value="Germany">Deutschland</option>
                    </select>
                    <label htmlFor="ck-bill-country">Land</label>
                  </div>
                </div>

                <div className="checkout-form-row">
                  <div className="checkout-field">
                    <input
                      type="text" id="ck-bill-postal" name="postal_code"
                      placeholder="Postleitzahl" required
                      onChange={handleBillingInputChange} value={billingAddress.postal_code}
                    />
                    <label htmlFor="ck-bill-postal">Postleitzahl</label>
                  </div>
                  <div className="checkout-field">
                    <input
                      type="text" id="ck-bill-city" name="city"
                      placeholder="Stadt" required
                      onChange={handleBillingInputChange} value={billingAddress.city}
                    />
                    <label htmlFor="ck-bill-city">Stadt</label>
                  </div>
                </div>

                <div className="checkout-form-row full">
                  <div className="checkout-field">
                    <input
                      type="text" id="ck-bill-address" name="address_line1"
                      placeholder="Adresse" required
                      onChange={handleBillingInputChange} value={billingAddress.address_line1}
                    />
                    <label htmlFor="ck-bill-address">Adresse</label>
                  </div>
                </div>

                <div className="checkout-form-row full">
                  <div className="checkout-field">
                    <input
                      type="text" id="ck-bill-apartment" name="address_line2"
                      placeholder="Wohnung, Suite usw. (optional)"
                      onChange={handleBillingInputChange} value={billingAddress.address_line2}
                    />
                    <label htmlFor="ck-bill-apartment">Wohnung, Suite usw. (optional)</label>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Scheduled delivery — only shown if any cart item requires it */}
          {requiresScheduling && (
          <div className="checkout-schedule">
            <h2 className="checkout-schedule-title">Geplante Lieferung</h2>
            <p className="checkout-schedule-subtitle">
              Bitte wählen Sie Datum und Uhrzeit für Ihre Lieferung
            </p>

            <div className="checkout-schedule-row">
              <div className="checkout-schedule-group">
                <label>Lieferdatum</label>
                <div
                  className="form-control"
                  onClick={() => setCalendarVisible(!calendarVisible)}
                >
                  {selectedDate ? moment(selectedDate).format('DD.MM.YYYY') : 'Datum wählen'}
                </div>
                {calendarVisible && (
                  <Calendar
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    tileDisabled={({ date }) => isClosedDay(date)}
                  />
                )}
              </div>

              <div className="checkout-schedule-group">
                <label>Uhrzeit</label>
                <select value={selectedTime} onChange={handleTimeChange} className="form-control">
                  <option value="" disabled>Uhrzeit wählen</option>
                  {availableHours.map((slot, index) => (
                    <option key={index} value={slot.hour}>{slot.hour}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          )}

          <div className="checkout-schedule">
            <div className="checkout-instructions">
              <label htmlFor="ck-instructions">Besondere Bestellhinweise</label>
              <textarea
                id="ck-instructions"
                value={specialInstructions}
                onChange={(e) => setSpecialInstructions(e.target.value)}
                placeholder="Haben Sie besondere Wünsche zu Ihrer Bestellung?"
              />
            </div>

            <button
              className="checkout-proceed-btn"
              onClick={handleCheckout}
              disabled={(requiresScheduling && !selectedTime) || loading}
            >
              Weiter zur Zahlung
            </button>

            {requiresScheduling && !selectedTime && (
              <p className="checkout-warning">
                Bitte wählen Sie eine Uhrzeit, bevor Sie fortfahren.
              </p>
            )}
          </div>
        </div>

        {/* ── Right column: Order summary ── */}
        <div className="checkout-summary">
          <h2 className="checkout-section-title">Bestellübersicht</h2>

          {updateError && <p style={{ color: 'red' }}>{updateError}</p>}

          {cart?.items?.length > 0 ? (
            <>
              {cart.items.map((cartItem) => (
                <div className="checkout-item" key={cartItem.id}>
                  <img
                    className="checkout-item-image"
                    src={cartItem.item.mainimage ? getImageURL(cartItem.item.mainimage) : 'placeholder.jpg'}
                    alt={cartItem.item.title}
                  />
                  <div className="checkout-item-info">
                    <p className="checkout-item-title">{cartItem.item.title}</p>
                    <p className="checkout-item-price">CHF {(parseFloat(cartItem.item.discount_price) || parseFloat(cartItem.item.price) || 0).toFixed(2)}</p>
                  </div>
                  <div className="checkout-item-controls">
                    <button
                      className="checkout-qty-btn"
                      onClick={() => handleUpdateQuantity(cartItem.item.slug, cartItem.quantity - 1)}
                      disabled={updating || cartItem.quantity <= 1}
                    >−</button>
                    <span className="checkout-qty-value">{cartItem.quantity}</span>
                    <button
                      className="checkout-qty-btn"
                      onClick={() => handleUpdateQuantity(cartItem.item.slug, cartItem.quantity + 1)}
                      disabled={updating}
                    >+</button>
                    <button
                      className="checkout-remove-btn"
                      onClick={() => handleRemoveItem(cartItem.item.slug)}
                      disabled={removing}
                    >
                      <RiDeleteBinLine />
                    </button>
                  </div>
                </div>
              ))}

              {/* Totals */}
              <div className="checkout-totals">
                <div className="checkout-total-row">
                  <span>Zwischensumme ({totalItems} Artikel)</span>
                  <span>CHF {couponresult?.new_total ? couponresult.new_total.toFixed(2) : cart.total_price.toFixed(2)}</span>
                </div>
                <div className="checkout-total-row">
                  <span>Liefergebühr</span>
                  <span>{deliveryFee === 0 ? <span style={{color:'#2e7d32', fontWeight:600}}>Kostenlos</span> : `CHF ${Number(deliveryFee).toFixed(2)}`}</span>
                </div>
                {cart.total_price < FREE_SHIPPING_THRESHOLD && (
                  <div className="checkout-free-shipping-hint">
                    🚚 Kostenloser Versand ab CHF {FREE_SHIPPING_THRESHOLD}.– – nur noch CHF {(FREE_SHIPPING_THRESHOLD - cart.total_price).toFixed(2)}!
                  </div>
                )}
                <div className="checkout-total-row grand">
                  <span>Gesamt</span>
                  <span>CHF {paymentTotal.toFixed(2)}</span>
                </div>
              </div>

              {/* Coupon */}
              <div className="checkout-coupon">
                <p className="checkout-coupon-title">Haben Sie einen Promo-Code?</p>
                <p className="checkout-coupon-desc">
                  Geben Sie Ihren Aktionscode ein, um einen Rabatt zu erhalten
                </p>
                {message && <p className="checkout-coupon-message">{message}</p>}
                <div className="checkout-coupon-row">
                  <input
                    type="text"
                    placeholder="Promo-Code eingeben"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <button className="checkout-coupon-apply" onClick={handleApplyCoupon}>
                    Anwenden
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p>Keine Artikel im Warenkorb.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewCheckoutDe;